const { createApp, ref, reactive, computed, watch, nextTick, onMounted } = Vue;
const eventBus = mitt();
function waitOneSecond() {
  return new Promise((resolve) => {
    setTimeout(resolve, 1000); // Wait for 1000 milliseconds (1 second)
  });
}
var clearIconTimeout;
function calHeight() {
  const mainContainer = document.querySelector(
    ".main-slideshow-wrap  .product__media-item"
  );
  const media = document.querySelector(".product-media-container");
  const h = mainContainer.clientHeight;
  // mainContainer.style.height = h + "px";
  document.documentElement.style.setProperty("--vh", `${h}px`);
  document.documentElement.style.setProperty("--ih", `${media.clientHeight}px`);

  // document.querySelector(".crop-wrapper").style.width = w + "px";

  // console.log({ height: media.clientHeight });
}
const openDB = (db = "artwork_db") => {
  return new Promise((resolve, reject) => {
    const request = window.indexedDB.open(db, 1);

    request.onerror = (event) => {
      reject(`IndexedDB error: ${event.target.error}`);
    };

    request.onsuccess = (event) => {
      resolve(event.target.result);
    };

    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains("images")) {
        db.createObjectStore("images", { autoIncrement: true });
      }
    };
  });
};
const storeBase64InDB = (base64Image, db_name = "artwork_db") => {
  openDB(db_name)
    .then((db) => {
      const transaction = db.transaction(["images"], "readwrite");
      const objectStore = transaction.objectStore("images");
      const request = objectStore.add(base64Image);

      request.onsuccess = () => {
        console.log("Base64 image stored successfully in IndexedDB");
      };

      request.onerror = (event) => {
        console.error(
          "Error storing base64 image in IndexedDB:",
          event.target.error
        );
      };
    })
    .catch((error) => {
      console.error("Error opening IndexedDB:", error);
    });
};
const getImageFromDB = () => {
  const url = new URL(window.location);
  let dbName = "artwork_db";
  if (url.searchParams.has("base64")) {
    dbName = "my_database";
  }
  return new Promise((resolve, reject) => {
    openDB(dbName)
      .then((db) => {
        const transaction = db.transaction(["images"], "readonly");
        const objectStore = transaction.objectStore("images");
        const request = objectStore.getAll();

        request.onsuccess = () => {
          const images = request.result;
          if (images.length > 0) {
            const base64Image = images[images.length - 1]; // Assuming the latest image is stored last
            resolve(base64Image);
          } else {
            reject("No image found in IndexedDB");
          }
        };

        request.onerror = (event) => {
          reject(`Error fetching image from IndexedDB: ${event.target.error}`);
        };
      })
      .catch((error) => {
        reject(`Error opening IndexedDB: ${error}`);
      });
  });
};
function base64ToBlob(base64DataUrl) {
  var parts = base64DataUrl.split(";base64,");
  var contentType = parts[0].split(":")[1];
  var raw = window.atob(parts[1]);
  var rawLength = raw.length;
  var uInt8Array = new Uint8Array(rawLength);

  for (var i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }

  return new Blob([uInt8Array], { type: contentType });
}
const Modal = {
  template: "#modal-template",
  setup() {
    const isVisible = ref(false);

    const close = () => {
      isVisible.value = false;
      eventBus.emit("close");
    };

    watch(isVisible, () => {
      document.body.classList.toggle("overflow-hidden");
    });

    eventBus.on("modal", () => {
      isVisible.value = !isVisible.value;
    });

    return {
      isVisible,
      close,
    };
  },
};
const placeholderImage =
  "https://cdn.shopify.com/s/files/1/0816/1928/8377/files/Screenshot_2024-04-24_135503.png?v=1713945426";
const filterImagePlaceholder = [
  {
    name: "original",
    url: placeholderImage,
    active: true,
    filter: "filter-normal",
  },
  {
    name: "chilly",
    url: placeholderImage,
    active: false,
    filter: "filter-amaro",
  },
  {
    name: "greyscale",
    url: placeholderImage,
    active: false,
    filter: "filter-inkwell",
  },
  {
    name: "soft",
    active: false,
    url: placeholderImage,
    filter: "filter-valencia",
  },
  {
    name: "mono",
    filter: "filter-moon",
    active: false,
    url: placeholderImage,
  },
  {
    name: "sunny",
    active: false,
    url: placeholderImage,
    filter: "filter-sutro",
  },
  {
    name: "vintage",
    active: false,
    url: placeholderImage,
    filter: "filter-kelvin",
  },
];
const mhSlider = () => {
  const sliderID = document.querySelector('[id^="MH-Slider-"]');
  const next = document.querySelector('[id^="filter-button-next-"]');
  const prev = document.querySelector('[id^="filter-button-prev-"]');
  return new Swiper(sliderID, {
    slidesPerView: 4,
    centeredSlides: false,
    loop: true,
    spaceBetween: 10,
    navigation: {
      nextEl: next,
      prevEl: prev,
    },
    breakpoints: {
      500: {
        slidesPerView: 5,
        spaceBetween: 10,
        centeredSlides: false,
        loop: false,
      },
      750: {
        slidesPerView: 7,
        spaceBetween: 10,
        centeredSlides: false,
        loop: false,
      },
      1024: {
        slidesPerView: 5,
        spaceBetween: 10,
        centeredSlides: false,
        loop: false,
      },
      1300: {
        slidesPerView: 7,
        spaceBetween: 10,
        centeredSlides: false,
        loop: false,
      },
    },
  });
};
const crop = (viewMode = 3, aspectRatio = 1) => {
  var $image = document.querySelector("#image");
  var options = {
    aspectRatio,
    viewMode,
    dragMode: "move",
    movable: true,
    autoCrop: false,
    // preview: ".img-preview",
    crop: function (e) {
      e.preventDefault();
    },
    zoom: function (e) {
      if (e.detail.ratio > 1) {
        e.preventDefault();
      }
      // console.log(e.detail);
    },
    ready: function () {
      // Add a class to the image element when Cropper.js is initialized
      // const img = document.querySelector(".cropper-canvas img");
      // if (img.classList.length) {
      //   img.className = "";
      // }
      // img.classList.add("mh-inkwell");
      console.log("cropper ready");
      clearTimeout(clearIconTimeout);
      const icon = document.querySelector(".icon-show");
      if (icon) {
        icon.classList.add("show");
      }
      clearIconTimeout = setTimeout(() => {
        if (icon) {
          icon.classList.remove("show");
          console.log({ crop: isCropperActive.value });
        }
      }, 3000);
      calHeight();
    },
  };
  return new Cropper($image, options);
};

const getBorder = (name = "white") => {
  const border = {
    white: {
      name: "white",
      backgroundColor: "#ffffff",
      color: "#000000",
    },
    beige: {
      name: "beige",
      backgroundColor: "#F4EFE5",
      color: "#000000",
    },
    black: {
      name: "black",
      backgroundColor: "#000000",
      color: "#ffffff",
    },
    noBorder: {
      name: "No border",
      backgroundColor: "transparent",
      color: "#ffffff",
    },
  };
  return border[name];
};
const allFonts = {
  modern: {
    name: "Baskerville",
  },
  classic: {
    name: "Montserrat",
  },
  minimalist: {
    name: "Broadway",
  },
};
const getFont = (name = "modern") => {
  return allFonts[name].name;
};

const imageQualityObj = {
  "21 x 30": true,
  "30 x 40": true,
  "50 x 70": true,
  "40 x 50": true,
  "50 x 50": true,
  "70 x 100": true,
};
const portraitOrLandscape = (image, type = "landscape") => {
  // const url = new URL(image.startsWith("http://") ? image : `https:${image}`);
  // console.log({ url });

  return image;
};

const getImageUrl = async () => {
  let image;
  // check if it artwork template
  if (typeof window.productJSON === "object") {
    if( window.productJSON.images[1] ) {
      image = window.productJSON.images[1];
    } else{
    image = window.productJSON.featured_image;
    }
    // console.log({ image });

    return portraitOrLandscape(image, "portrait");
  } else {
    // its imaginator template
    const url = new URLSearchParams(window.location.search);

    try {
      if (url.get("base64")) {
        const base64Image = await getImageFromDB();
        const blob = base64ToBlob(base64Image);
        const blobUrl = URL.createObjectURL(blob);
        // console.log({ blobUrl });
        return blobUrl;
      } else {
        image = url.get("image") || localStorage.getItem("imageUrl");
        console.log(url.get("image"), image);

        return portraitOrLandscape(image, "portrait");
      }
    } catch (error) {
      console.error("Error retrieving image:", error);
      // Handle error or fallback
      return portraitOrLandscape(image, "portrait");
    }
  }
};

function preloadImage(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve();
    img.onerror = (error) => reject(error);
    img.src = url;
  });
}
const app = createApp({
  setup() {
    const showModal = ref(false);
    const mainImage = ref(placeholderImage);
    const image = ref(placeholderImage);
    const imageStyle = ref("portrait");

    const filterImage = ref([...filterImagePlaceholder]);
    const activeFilter = ref(filterImagePlaceholder[0].filter);
    const activeFilterName = ref(filterImagePlaceholder[0].name);
    const imageQuality = ref({ ...imageQualityObj });
    const headline = ref(window.translate.headline);
    const subheadline = ref(window.translate.subheadline);
    const fonts = reactive({ ...allFonts });
    const activeFont = ref(getFont());
    const border = ref(getBorder());
    const cropper = ref(null);
    const isCropperActive = ref(false);
    const deg = ref(0);
    const disabled = ref(false);
    const loading = ref(false);
    const frame = ref(false);
    const variant = ref(window.variant.option2);
    const currentVariant = ref({ ...window.variant });
    const variants = ref([...window.variants]);
    const options = ref([...window.options]);
    const option1 = ref([{}]);
    const option2 = ref([{}]);
    const checked = ref(window.variant.option1); // frame value checked
    const selectedSize = ref(window.variant.option2);
    const additionalProduct = ref(false);
    const additionalProductChecked = ref(false);
    const uploadFileText = ref(window.translate.upload_photo);
    const fileInput = ref(null);
    const isBase64Url = ref(false);
    const icons = ref(window.translate.icon);

    const openModal = () => {
      showModal.value = !showModal.value;
      eventBus.emit("modal");
    };

    const changeFont = (name, font) => {
      console.log({ name, font }, getFont(name ?? "modern"));
      activeFont.value = getFont(name ?? "modern");
    };
    const changeBorder = (name) => {
      calHeight();
      border.value = getBorder(name ?? "white");
    };

    const portrait = () => {
      imageStyle.value = "portrait";
    };
    const landscape = () => {
      imageStyle.value = "landscape";
    };
    const rotate = () => {
      deg.value = (deg.value + 90) % 360;
      cropper.value.rotateTo(deg.value);
    };

    const openEditor = () => {
      window.cropper = cropper.value = crop();
      isCropperActive.value = true;
    };
    const destroyCropper = () => {
      cropper.value.destroy();
      isCropperActive.value = false;
      clearTimeout(clearIconTimeout);
      const icon = document.querySelector(".icon-show");
      if (icon) {
        icon.classList.remove("show");
      }
    };
    const closeEditor = () => {
      const node = document.querySelector(".cropper-container.cropper-bg");
      loading.value = true;
      if (node) {
        domtoimage
          .toPng(node)
          .then(function (dataUrl) {
            var blob = base64ToBlob(dataUrl);

            // Create a URL object from the Blob
            var blobUrl = URL.createObjectURL(blob);

            // Use blobUrl as needed
            console.log(blobUrl);
            image.value = blobUrl;
          })
          .catch(function (error) {
            console.error("oops, something went wrong!", error);
          })
          .finally(() => {
            loading.value = false;
            destroyCropper();
          });
      } else {
        console.log(document.querySelector(".cropper-container.cropper-bg"));
        loading.value = false;
        destroyCropper();
      }
    };

    const resetCropper = () => {
      // need to reset the settings
      console.log("reset cropper");
      destroyCropper();
    };

    function destroyAndReinitCropper() {
      return new Promise((resolve, reject) => {
        cropper.value.destroy();
        setTimeout(() => {
          cropper.value = crop();
          resolve();
        }, 100);
      });
    }

    const filter = (filter, index, name) => {
      activeFilter.value = filter;
      activeFilterName.value = name;
      const prevIndex = filterImage.value.findIndex((filter) => filter.active);
      filterImage.value[prevIndex].active = false;
      filterImage.value[index].active = true;
      calHeight();
    };

    const changeFrame = (val, newVal) => { // newVal added by TT
      if (val === "Poster" || val === "Canvas") {
        additionalProduct.value = false;
      } else {
        additionalProduct.value = true;
      }
      document.querySelector('.prefix-frame-js').id = newVal; // this line added by TT

      checked.value = val;
    };
    const triggerFileInput = () => {
      fileInput.value.click();
    };
    const uploadFile = (event) => {
      const fileInput = event.target;
      if (fileInput.files && fileInput.files.length > 0) {
        const file = fileInput.files[0];
        //  fileName.value = file.name;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (event) => {
          const base64Image = event.target.result;
          const db_name = isBase64Url.value ? "my_database" : "artwork_db";
          storeBase64InDB(base64Image, db_name);
          getImageFromDB().then((base64Image) => {
            const blob = base64ToBlob(base64Image);
            const blobUrl = URL.createObjectURL(blob);
            image.value = mainImage.value = blobUrl;
            console.log(blobUrl);
            uploadFileText.value = window.translate.upload_new_photo;
          });
        };
        reader.onerror = (error) => {
          console.error("Error reading file:", error);
        };
        // storeBase64InDB(file);
        // console.log(getImageFromDB());

        //  uploadFileToServer(file);
      }
    };

    const addCart = () => {
      console.log("add cart");
      const node = document.querySelector(
        ".product-media-container.text-padding"
      );

      loading.value = true;

      domtoimage
        .toPng(node)
        .then(function (dataUrl) {
          var blob = base64ToBlob(dataUrl);

          // Create a URL object from the Blob
          var blobUrl = URL.createObjectURL(blob);

          // Use blobUrl as needed
          console.log(blobUrl);

          fetch(blobUrl)
            .then((response) => response.blob())
            .then((blob) => {
              console.log(blob);

              // Create a new File object from the Blob data
              var file = new File([blob], "imaginator.jpg", {
                type: "image/jpeg",
              });

              // Find the input element by its ID or other means
              var inputFile = document.getElementById("fileInput");

              // Create a new FileList object containing the File object
              var fileList = new DataTransfer();
              fileList.items.add(file);

              // Set the FileList object as the files property of the input element
              inputFile.files = fileList.files;

              // Trigger a change event on the input element to simulate a file upload
              inputFile.dispatchEvent(new Event("change"));

              if (
                typeof mainImage.value == "string" &&
                mainImage.value.startsWith("blob:")
              ) {
                const _mainImage = document.querySelector("#_mainImage");
                if (_mainImage) {
                  _mainImage.remove();
                }

                // Helper function to get file extension from MIME type
                function getExtensionFromMimeType(mimeType) {
                  const extensions = {
                    "image/jpeg": ".jpg",
                    "image/png": ".png",
                    "image/gif": ".gif",
                    "image/webp": ".webp",
                    // Add more mime types and extensions as needed
                  };
                  return extensions[mimeType] || "";
                }

                fetch(mainImage.value)
                  .then((response) => response.blob())
                  .then((blob) => {
                    // Get the file type from the blob
                    const fileType = blob.type;
                    console.log("File type:", fileType);

                    // Use the actual file type instead of hardcoding "image/png"
                    var blobFile = new File(
                      [blob],
                      "mainImage" + getExtensionFromMimeType(fileType),
                      {
                        type: fileType,
                      }
                    );

                    var mainImageFile =
                      document.getElementById("mainFileInput");

                    var mainFileList = new DataTransfer();
                    mainFileList.items.add(blobFile);
                    mainImageFile.files = mainFileList.files;
                    mainImageFile.dispatchEvent(new Event("change"));
                    document.querySelector(".imaginator-add-cart").click();
                  })
                  .catch((error) => console.error("Error:", error));
              } else {
                var mainImageFile = document.getElementById("mainFileInput");
                if (mainImageFile) {
                  mainImageFile.remove();
                }
                document.querySelector(".imaginator-add-cart").click();
              }
            })
            .catch((error) => {
              console.error("Error fetching Blob data:", error);
            });
        })
        .finally(() => {
          loading.value = false;
        });
    };
    function formatPrice(cents, id) {
      if (window.variantsJSON && window.variantsJSON[id]) {
        return window.variantsJSON[id].price;
      }

      const dollars = (cents / 100).toFixed(2);
      return `$${dollars}`;
    }
    function toHandle(str) {
      return str
        .toLowerCase() // Convert to lowercase
        .replace(/\s+/g, "-") // Replace spaces with hyphens
        .replace(/[^a-z0-9-]/g, "") // Remove special characters
        .replace(/-+/g, "-") // Replace multiple hyphens with a single hyphen
        .replace(/^-+|-+$/g, ""); // Remove leading and trailing hyphens
    }

    function getImage(index) {
      return window.optionsJSON[index].variant_image;
    }

    const changePrice = (id) => {
      const v = window.variantsJSON[currentVariant.value.id];
      const sale = document.querySelector(".price-item--sale");
      const compare = document.querySelector(".price-item--regular");
      const save = document.querySelector("#update-discount-price-js");
      if (sale) {
        sale.innerHTML = v.price;
      }
      if (compare) {
        compare.innerHTML = v.compare_at_price;
      }
      if (save) {
        save.innerHTML = v.save;
      }
    };

    /**
     * Watch section
     */

    watch(isCropperActive, () => {
      setTimeout(calHeight, 100);
    });

    watch(
      variant,
      () => {
        option1.value = variants.value.filter(
          (v) => v.option2 === selectedSize.value
        );
        currentVariant.value = option1.value.find(
          (v) => v.option1 == checked.value
        );
        // console.log(currentVariant.value);
        changePrice(currentVariant.value.id);
      },
      { immediate: true }
    );

    watch(selectedSize, (newVal) => {
      variant.value = newVal;
    });
    watch(checked, (newVal) => {
      variant.value = newVal;
    });
    watch(image, (img) => {
      console.log(img);

      filterImage.value = filterImage.value.map((image) => {
        image.url = img;
        return image;
      });
    });

    watch(imageStyle, () => {
      disabled.value = true;
      preloadImage(mainImage.value)
        .then(() => {
          // Once image is preloaded, update image value
          image.value = portraitOrLandscape(mainImage.value, imageStyle.value);
        })
        .catch((error) => {
          console.error("Error preloading image:", error);
        })
        .finally(async () => {
          await destroyAndReinitCropper();
          disabled.value = false;
          calHeight();
        });
    });

    eventBus.on("close", () => {
      showModal.value = !showModal.value;
    });
    onMounted(async () => {
      console.log("init the product app");
      const url = new URLSearchParams(window.location.search);
      if (url.get("base64")) {
        isBase64Url.value = true;
      }
      option2.value = variants.value.filter((v) => v.option1 === checked.value);
      try {
        const imageUrl = await getImageUrl();
        image.value = mainImage.value = imageUrl;
        console.log(image.value);
      } catch (error) {
        console.error("Error fetching image URL:", error);
        // Handle error gracefully
      }
      mhSlider();
      calHeight();
      setTimeout(() => {
        var productTypeSlider = new Swiper(".p-variants-js", {
          slidesPerView: 3,
          // Navigation arrows
          navigation: {
            nextEl: ".swiper-button-next-js",
            prevEl: ".swiper-button-prev-js",
          },
          breakpoints: {
            990: {
              slidesPerGroup: 4,
              slidesPerView: 4,
            },
            1024: {
              slidesPerGroup: 4,
              slidesPerView: 4,
              grid: {
                rows: 2,
              },
            },
          },
        });
      }, 500);
      window.addEventListener("resize", function () {
        // Your code to handle the resize event
        console.log("Window has been resized!");
        calHeight();
        // Perform actions based on the new window size
      });
    });
    return {
      mainImage,
      image,
      filterImage,
      activeFilter,
      activeFilterName,
      imageQuality,
      headline,
      subheadline,
      showModal,
      fonts,
      activeFont,
      border,
      imageStyle,
      disabled,
      loading,
      isCropperActive,
      cropper,
      frame,
      currentVariant,
      checked,
      options,
      option1,
      option2,
      selectedSize,
      additionalProduct,
      additionalProductChecked,
      uploadFileText,
      fileInput,
      isBase64Url,
      icons,
      openModal,
      changeFont,
      changeBorder,
      portrait,
      landscape,
      rotate,
      openEditor,
      closeEditor,
      resetCropper,
      filter,
      addCart,
      changeFrame,
      formatPrice,
      toHandle,
      uploadFile,
      triggerFileInput,
      getImage,
    };
  },
});

// Register the modal component
app.component("modal", Modal);
// app mount
app.mount("#mh-app");
